export default {
  directlySaleCompanyIds (state) {
    return state.directlySaleCompanyIds;
  },
};
